export const GoogleMapApiConfig = 'AIzaSyCte9Q64v_FFTPRRnbaFFJZ7mGvyEIcTIQ';